import { render, staticRenderFns } from "./Double11_2021.vue?vue&type=template&id=c4d5826e&scoped=true&"
import script from "./Double11_2021.vue?vue&type=script&lang=js&"
export * from "./Double11_2021.vue?vue&type=script&lang=js&"
import style0 from "./Double11_2021.vue?vue&type=style&index=0&id=c4d5826e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d5826e",
  null
  
)

export default component.exports